import React, { FC } from 'react';
import BgImage from 'assets/images/overview-card-bg.png';
import { Button } from '@cokitchen/cokitchen-components';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

export type OverviewCardType = {
  icon: JSX.Element;
  title: string;
  desc: string;
  ctaText: string;
  ctaFn: () => void;
  currentValue?: string;
  count?: string;
  hide?: boolean;
};

const OverviewCard: FC<OverviewCardType> = ({
  icon,
  title,
  ctaFn,
  ctaText,
  desc,
  currentValue,
  count,
  hide
}) => {
  const { role } = useRoleContext();
  const canManageSurge = role !== ENUM_ROLE.LOGISTICS_ADMIN;

  if (hide) return null;
  return (
    <div className='flex gap-x-3.5 relative bg-[#faf5f6] min-h-[129px] rounded-[10px] px-4 py-4'>
      <img className='absolute z-0 right-0 top-0' src={BgImage} alt='Icon' />
      <span className='pt-1'>{icon}</span>

      <div className='flex flex-col items-start relative'>
        <div className='flex items-center justify-between w-full mb-1'>
          <h3 className='font-medium'>{title}</h3>
          {Number(count) > 0 && (
            <span className='bg-red-5 rounded-3xl px-2 p-0.5 text-white text-xs font-medium'>
              {count} new
            </span>
          )}
        </div>
        <p className='text-xs text-gray-8 grow mb-2'>{desc}</p>
        {canManageSurge || currentValue === undefined ? (
          <Button color='primary' className='underline' variant='link' onClick={ctaFn}>
            {ctaText}
          </Button>
        ) : (
          <span className='text-red-5 leading-[26px]'>{currentValue}</span>
        )}
      </div>
    </div>
  );
};

export default OverviewCard;
